/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ModelLiveDeploymentState {

    Staged = 'staged',

    PaperActive = 'paper_active',

    CapitalCanaryActive = 'capital_canary_active',

    Suspended = 'suspended',

    Retired = 'retired'
}
